import { v4 } from "uuid";

export class DrawerLink {
	uid: string = v4();
	Icon: string = "icon-external";
	Name: string = "";
	Title: string = "";
	Url: string = "";
	DevOnly: boolean = true;
	UseDesktopAppAsProxy: boolean = false;

	public constructor(data?: any) {
		if (!data) return;
		this.uid = data.uid || v4();
		this.Icon = data.Icon || "icon-external";
		this.Name = data.Name || "";
		this.Title = data.Title || "";
		this.Url = data.Url || "";
		this.DevOnly = data.DevOnly !== undefined ? data.DevOnly : true;
		this.UseDesktopAppAsProxy = data.UseDesktopAppAsProxy || false;
	}

	public getJSON() {
		return {
			uid: this.uid,
			Icon: this.Icon,
			Name: this.Name,
			Title: this.Title,
			Url: this.Url,
			DevOnly: this.DevOnly,
			UseDesktopAppAsProxy: this.UseDesktopAppAsProxy
		};
	}
}
